import React, { useState } from "react";
import { FaClockRotateLeft } from "react-icons/fa6";
import HistoryPopup from "./HistoryPopup";
import { useTranslation } from "../hooks/useTranslation";

const Header = ({ username = "Xxx Xxx" }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { t } = useTranslation();

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };
  return (
    <>
      <div className="header-container">
        <div className="header-content">
          <h1 className="header-title" style={{marginLeft: "30px", color: "var(--header-title-color)" }}>
            <div
              className="history-icon"
              onClick={openPopup}
              style={{
                color: "var(--header-icon-color)",
                backgroundColor: "var(--header-icon-bg-color)",
              }}
            >
              <FaClockRotateLeft size={24} />
            </div>
            <span className="welcome-text">{t('header.welcome','Hoşgeldin')}</span>{" "}
            <span className="username-text">, {username}</span>
          </h1>
          <p
            className="header-subtitle"
            style={{ color: "var(--header-subtitle-color)" }}
          >
            {t('header.subtitle', 'Lütfen talep etmek istediğiniz bonusu seçiniz.')}
          </p>
        </div>
      </div>
      <HistoryPopup isOpen={isPopupOpen} onClose={closePopup} />
    </>
  );
};

export default Header;
